import { MMKV } from 'react-native-mmkv';
import { Platform } from 'react-native';

const seenInSession = new Set<string>();
let storage: MMKV | null = null;
export const checklistActionsTipKey = (userId: string): string =>
  `onboarding:checklist_actions_moved_v1:${userId}`;

export const hasSeenChecklistActionsTip = (userId: string): boolean => {
  const key = checklistActionsTipKey(userId);
  if (seenInSession.has(key)) return true;
  try {
    if (Platform.OS === 'web') return typeof window !== 'undefined' && window.localStorage?.getItem(key) === '1';
    storage ??= new MMKV({ id: 'onboarding-checklist-share' });
    return storage.getString(key) === '1';
  } catch { return false; }
};

export const markChecklistActionsTipSeen = (userId: string): void => {
  const key = checklistActionsTipKey(userId);
  seenInSession.add(key);
  try {
    if (Platform.OS === 'web') {
      if (typeof window !== 'undefined') window.localStorage?.setItem(key, '1');
    } else {
      storage ??= new MMKV({ id: 'onboarding-checklist-share' });
      storage.set(key, '1');
    }
  } catch { /* Sem storage persistente, exibe apenas uma vez nesta sessão. */ }
};
